import PropTypes from 'prop-types';
import panels from './panels';
import _ from 'lodash';

/**
 * @typedef {object} DashboardData
 * @prop {Panel[]} panels
 */

/**
 * @typedef {object} DashboardType
 * @prop {string} [id]
 * @prop {string} [displayName]
 * @prop {string} [name]
 * @prop {DashboardData} data
 */
export const DashboardPropType = PropTypes.shape({
  id: PropTypes.string,
  displayName: PropTypes.string,
  name: PropTypes.string, // Obsolete, use displayName and fallback to this
  data: PropTypes.shape({
    panels: PropTypes.array
  })
});

export const PanelPropType = PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.oneOf(_.keys(panels))
});
